import {
  CustomerPortal,
  CustomerPortalPage,
  PortalMeta,
} from 'api/customer-portal/types';

export class CustomerPortalModel implements CustomerPortal {
  customerPortalId: number;

  customerPortalName: string;

  createdAt?: number | undefined;

  createdBy?: number | undefined;

  pages: CustomerPortalPage[];

  portalMeta: PortalMeta;

  updatedAt?: number | undefined;

  updatedBy?: number | undefined;

  customerPortalThemeId: number;

  constructor(cp: CustomerPortal) {
    this.customerPortalId = cp.customerPortalId;
    this.customerPortalName = cp.customerPortalName;
    this.createdBy = cp.createdBy;
    this.createdAt = cp.createdAt;
    this.updatedBy = cp.updatedBy;
    this.updatedAt = cp.updatedAt;
    this.pages = cp.pages;
    this.portalMeta = cp.portalMeta;
    this.customerPortalThemeId = cp.customerPortalThemeId;
  }
}
